var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 14c0 5.523 4.477 10 10 10s10-4.477 10-10S19.523 4 14 4 4 8.477 4 14z",
    stroke: "#2C2D2E",
    strokeWidth: 2.222,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 19a1 1 0 01-1-1v-4a1 1 0 112 0v4a1 1 0 01-1 1z",
    fill: "#2C2D2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10a1 1 0 112 0 1 1 0 01-2 0z",
    fill: "#2C2D2E"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQgMTRDNCAxOS41MjI4IDguNDc3MTUgMjQgMTQgMjRDMTkuNTIyOCAyNCAyNCAxOS41MjI4IDI0IDE0QzI0IDguNDc3MTUgMTkuNTIyOCA0IDE0IDRDOC40NzcxNSA0IDQgOC40NzcxNSA0IDE0WiIgc3Ryb2tlPSIjMkMyRDJFIiBzdHJva2Utd2lkdGg9IjIuMjIyMjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE0IDE5QzEzLjQ0NzcgMTkgMTMgMTguNTUyMyAxMyAxOEwxMyAxNEMxMyAxMy40NDc3IDEzLjQ0NzcgMTMgMTQgMTNDMTQuNTUyMyAxMyAxNSAxMy40NDc3IDE1IDE0TDE1IDE4QzE1IDE4LjU1MjMgMTQuNTUyMyAxOSAxNCAxOVoiIGZpbGw9IiMyQzJEMkUiLz4KPHBhdGggZD0iTTEzIDEwQzEzIDkuNDQ3NzEgMTMuNDQ3NyA5IDE0IDlDMTQuNTUyMyA5IDE1IDkuNDQ3NzEgMTUgMTBDMTUgMTAuNTUyMyAxNC41NTIzIDExIDE0IDExQzEzLjQ0NzcgMTEgMTMgMTAuNTUyMyAxMyAxMFoiIGZpbGw9IiMyQzJEMkUiLz4KPC9zdmc+Cg==";
export { SvgInfoIcon as ReactComponent };